(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Lógica original del header estático de Shopify
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.header-wrapper');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      window.addEventListener('scroll', this.onScroll.bind(this), false);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 50) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }
      this.currentScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  // Script para que el botón morado muestre/oculte el menú lateral
  document.addEventListener("DOMContentLoaded", function() {
    const toggleBtn = document.querySelector('header-drawer summary');
    const sidebar = document.getElementById('GcSidebar');
    const mainContent = document.getElementById('MainContent');
    const footer = document.getElementById('shopify-section-footer');

    if(toggleBtn && sidebar) {
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (sidebar.style.display === 'none' || sidebar.style.display === '') {
          sidebar.style.display = 'block';
          if(mainContent) mainContent.style.paddingLeft = '260px';
          if(footer) footer.style.paddingLeft = '260px';
        } else {
          sidebar.style.display = 'none';
          if(mainContent) mainContent.style.paddingLeft = '0';
          if(footer) footer.style.paddingLeft = '0';
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
